<template>
  <div v-if="files.length" class="cooperation-page__uploads">
    <div class="cooperation-page__uploads-title">{{$tCooperation('Already uploaded')}}:</div>

    <div class="cooperation-page__upload-files-list">
      <div
        v-for="(file, index) in files"
        class="cooperation-page__upload-file"
        :key="index"
      >
        <div class="cooperation-page__upload-file-details">
          <span class="cooperation-page__upload-file-title">{{ file.name }}</span>
          <span class="cooperation-page__upload-file-type">{{ file.ext }}</span>
          <span class="cooperation-page__upload-file-weight">{{ formatSize(file.size) }}</span>
        </div>

        <BaseSvg
          class="cooperation-page__upload-file-close"
          name="ico-close"
          @click.native="$emit('remove', { file, index })"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'files' ],

    data() {
      return {
        sizeList: [ 'b', 'Kb', 'Mb', 'Gb' ]
      };
    },

    methods: {
      formatSize(size, lvl = 0) {
        if (size >= 1024 && lvl < this.sizeList.length - 1) return this.formatSize(size / 1024, lvl + 1);
        return size.toFixed(2).replace('.00', '') + this.sizeList[ lvl ];
      }
    }
  };
</script>
